import { render, staticRenderFns } from "./BinPrintModal.vue?vue&type=template&id=6505f802"
import script from "./BinPrintModal.vue?vue&type=script&lang=ts"
export * from "./BinPrintModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports